
jQuery(document).ready(function($){
  
     // PDP Descriptions 
      $('.product-short-desc p').each(function() {
      var words = $(this).text().split(' ');
      if (words.length > 40) {
        var trimmed = words.slice(0, 40).join(' ');
        var readMore = '... <a href="#heading-1" class="read-more">Read more</a>';
        $(this).html(trimmed + readMore);
      }
    });


    //LIFELY SOFA PRE-ORDER ON COLLECTIONS
 function updateLifelyModularSofaBadge() {
    var updated = false;
    // Loop through each product card
    $('#main-collection-product-grid li').each(function() {
      var card = $(this);
      // Look for product links that include "lifely-modular-sofa" (case-insensitive)
      var productLink = card.find('a.full-unstyled-link').filter(function() {
        var href = $(this).attr('href');
        return href && href.toLowerCase().indexOf('lifely-modular-sofa') !== -1;
      });

      if (productLink.length > 0) {
        card.find('.ss__badge-rectangle').attr('style','background:#192d59;');
        console.log('Found product card for:', productLink.text().trim());
        // Find all badge value elements in this card and update if text is "In-Stock"
        card.find('.ss__badge-rectangle__value').each(function() {
          var $badge = $(this);
          var badgeText = $badge.text().trim();
          if (badgeText.toLowerCase() === 'in-stock') {
            $badge.text('Pre-order');
            updated = true;
            console.log('Updated badge text to Pre-order for:', productLink.text().trim());
          } else {
            console.log('Badge text is not "In-Stock":', badgeText);
          }
        });
      }
    });
    
    if (!updated) {
      console.log('No badges updated on this run.');
    }
  }

  // Run the function immediately
  updateLifelyModularSofaBadge();

  // Run again after 2 seconds (for dynamically loaded content)
  setTimeout(updateLifelyModularSofaBadge, 2000);

  
     $('.header__menu-item:contains("Bundles")').text("Bundles");
    

  
  if($('body').hasClass('product_combo-product')){
      setTimeout(function(){
        // $('.product-form').insertBefore($('.product__description'));
        // $('.post_check_main_grid').insertAfter($('.product-form'));
        
      }, 3000)
    }else if($('body').hasClass('product_mattress-deepdream')){
      $('.product__description').insertBefore($('#accordion_deepdream'));
      $('.product_payement_logo_new').insertAfter($('.discount_sale_bar_section'));
    
    }
   setTimeout(function(){
    $('.mid-sale-discount-batches.one-column').removeClass('hide-bar')

  }, 2000)
var $announcementBar = $('#shopify-section-announcement-bar');

if ($announcementBar.length) {
  var offset = $announcementBar.offset().top;
  console.log('Offset:', offset);
} else {
  console.log('#shopify-section-announcement-bar not found');
}

    $(window).on('scroll', function () {
        if ($(window).scrollTop() > offset) {
            $announcementBar.addClass('stickyAncBar'); // Add sticky class
        } else {
            $announcementBar.removeClass('stickyAncBar'); // Remove sticky class
        }
    });


  setTimeout(function(){

      $('.price-section').show();
   
   }, 300)

  $( ".product-form__submit" ).on( "click", function() {
     setTimeout(function(){

        $("#cart-icon-bubble").trigger('click');
       
       }, 3000)
  } );

   $('.preorder_discout_bar').hide();
   setTimeout(function(){
    
  
  var salePrice = $('.price__sale .price-item--regular');
    var regularPrice = $('.price__sale .price-item--last');

    // Check if the "AUD" text is present
    if (salePrice.length && salePrice.text().includes('AUD')) {
      salePrice.text(function(_, txt) {
        return txt.replace('AUD', '').trim();
      });
    }

    if (regularPrice.length && regularPrice.text().includes('AUD')) {
      regularPrice.text(function(_, txt) {
        return txt.replace('AUD', '').trim();
      });
    }

  // $("input[value='King Single']").trigger('click');
     
}, 2000)


        	/* TOOLTIP FUNCTION */

       setTimeout(function(){

      $('.pin-modal__content').each(function() {
      
      var price =  $(this).find('.js-im-price').text().slice(1,$(this).find('.js-im-price').text().length-3);
     price = price.replace(/,/g, '');
     console.log("EACH DISCOUNT" , price);
      var discount = Math.round(price * 0.7);
     console.log("EACH DISCOUNT" , discount);
      $(this).find('.pin-modal__price').prepend('<span class="js-disc-price"> $'+discount+'.00</span>')
      
      });
   
   }, 4000)
  
    setTimeout(function(){
    

   var buttonText = $('#product_detail_custom_add_to_cart span').text().trim();
    
    if (buttonText === "Pre-order Now") {
        $('.preorder_discout_bar').show();
        console.log("The button text is 'Pre-order Now'.");
      // Step 1: Extract the .delivery_detail HTML
      var deliveryDetailHtml = $('.post_check_main_grid .delivery_date').html();
      
      // Step 2: Update the preorder_discout_bar HTML
      $('.radio-est-arrival .delivery_date').html(deliveryDetailHtml);
        // Add any other actions you want to perform
    } else {
        
    }
  }, 4000)
  // setTimeout(function(){
  //   $('.announcement-bar-timer .clearance_BannerBar_Timmer').html('<p class="ancment-end-offer">Don\'t miss out, Sale ends soon !</p>');
  //   $('#countdownClearance_bar').show();
  //   $('.clearance_banner_bar').show();
    
  //   $('#countdownClearance_bar').html('<p class="ancment-end-offer">Don\'t miss out, Sale ends soon !</p>');
  // }, 3000)
  
    if ($('body').hasClass('product-7405843349546')) {
      setTimeout(function(){
          $('.combo-radio-btn.detail-btn.stick label:nth-of-type(2)').contents().filter(function(){
                return this.nodeType === 3 && $.trim(this.nodeValue) === "Cali Bed Base";
            }).replaceWith(" Cali Bed Frame ");
        $('.container.combo-radio-btn.desc-btn label').contents().filter(function(){
                return this.nodeType === 3 && $.trim(this.nodeValue) === "Cali Bed Base";
            }).replaceWith(" Cali Bed Frame ");
      }, 4000)
    }
//////////////////////////////////////////////////////////////////////////////////////////////StartquickView/////////////////////////////////////////////////////////////////////////////////////////   // SVG data URL
    var svgDataUrl = 'data:image/svg+xml;base64,' + btoa(`
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="32" height="32" rx="16" fill="#2C474B"></rect><path d="M21.9983 22.1668L21.9975 22.1668C21.9756 22.1669 21.9538 22.1627 21.9336 22.1544C21.9135 22.1462 21.8952 22.1342 21.8797 22.1189L18.9989 19.2381C18.9768 19.2079 18.9655 19.171 18.9669 19.1334C18.9685 19.0914 18.9859 19.0516 19.0156 19.022C19.0453 18.9923 19.0851 18.9749 19.127 18.9733C19.1647 18.9718 19.2015 18.9832 19.2318 19.0052L22.1125 21.8859C22.1126 21.886 22.1127 21.8862 22.1128 21.8863C22.1436 21.9174 22.161 21.9596 22.161 22.0034C22.161 22.0469 22.144 22.0886 22.1137 22.1197C22.0828 22.1497 22.0415 22.1666 21.9983 22.1668Z" fill="black" stroke="white"></path><path d="M20.6471 15.3334C20.6471 16.3882 20.3343 17.4193 19.7483 18.2964C19.1623 19.1735 18.3293 19.8571 17.3548 20.2607C16.3802 20.6644 15.3079 20.77 14.2733 20.5642C13.2388 20.3584 12.2884 19.8505 11.5426 19.1046C10.7967 18.3587 10.2887 17.4084 10.0829 16.3739C9.87716 15.3393 9.98278 14.2669 10.3864 13.2924C10.7901 12.3179 11.4737 11.4849 12.3508 10.8989C13.2278 10.3128 14.259 10 15.3138 10C16.0159 9.9974 16.7115 10.1334 17.3609 10.4003C18.0103 10.6671 18.6006 11.0595 19.098 11.5551C19.5953 12.0506 19.99 12.6394 20.2593 13.2878C20.5285 13.9361 20.6671 14.6313 20.6671 15.3334H20.6471Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>`);
    // setTimeout(function(){
      
    
   // Create a style element
    var style = document.createElement('style');
    style.type = 'text/css';
    style.innerHTML = `
    .quick-view-button a.quick-view:before {
        background-image: url(${svgDataUrl}) !important;
        background-size: contain;
        background-repeat: no-repeat;
        display: inline-block;
        background-color: #2c474b !important;
        width: 44px !important;
        height: 44px !important;
        content: "";
    }`;

    // Append the style element to the head
    document.getElementsByTagName('head')[0].appendChild(style);
  // }, 3000)
    $('body').on('click', '.quick-view-button', function(){
      var salePrice = $(this).closest('.card-wrapper')
                               .find('.price-item--sale.price-item--last')
                               .text().trim();
      setTimeout(function(){
        $('.qv-product-price span').text(salePrice)
      }, 1000)  
        console.log(salePrice); // This will log the sale price, e.g., "$321.30"
    })
  //////////////////////////////////////////////////////////////////////////////////////////////EndquickView/////////////////////////////////////////////////////////////////////////////////////////
  
   $('.mattress_products_grid_c').each(function(index) {
      $(this).find('.fration').text((index + 1) + '/6');
  });
  $('#shopify-section-template--14966969597994__mattress_product_grid_GxGQ8G .range-wrapper').remove();
  $('#shopify-section-template--14966969597994__mattress_product_grid_GxGQ8G .mattress_collection_product_grid_section').css({'padding': '0 0 40px'});
   //////////////////////////////////////////////////30%OFF//////////////////////////////////////////////////////

//  // select the target node
// var target = document.getElementById('searchspring-content');

// // create an observer instance, safari via webkit
// var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

// // Check if the target exists before creating the observer
// if (target) {
//     // create the observer
//     var observer = new MutationObserver(function(mutations) {
//         mutations.forEach(function(mutation) {
//             console.log(mutation);
//             console.log(mutation.type);
//             console.log("mutated");
//             priceUpdateOff();
//         });
//     });

//     // configuration of the observer:
//     var config = { attributes: true, childList: true, characterData: true };

//     // pass in the target node, as well as the observer options
//     observer.observe(target, config);
// } else {
//     console.log("Target node not found");
// }

// function priceUpdateOff() {
//     $(".ss__result").each(function() {

//        // var excludedTitles = [
//        //      "Lara Coffee Table", "Tate Extendable Dining Table", "Alfie Bed Frame", "Hank Bedside Table", "Willy Office Desk",
//        //      "Cece Mirror", "Kathryn Rug", "Elena Bed Frame", "Sienna Coffee Table", "Tim Office Chair", "Diri Display Cabinet",
//        //      "Cary Sofa", "Ilia Bedside Table", "Jax Display Cabinet", "Maves Display Cabinet", "Layla Bed Frame", "Frank Armchair - Tweed",
//        //      "Silla Display Cabinet", "Amber Set of 2 Dining Chair - Green", "Ella Bed Frame", "Hazel Coffee Table", "Rodney 6 Chest of Drawers",
//        //      "Zaria Mirror", "Amir Coffee Table", "Cloud Coffee Table - Russet", "Benji Armchair", "Stella Bed Frame", "Max Sofa",
//        //      "Jace Sofa", "Larry TV Unit", "Theo Sideboard", "Luna Chair", "Mateo Bedside Table", "Caleb Desk", "Elias Sideboard",
//        //      "Grun 6 Seater Dining Table", "Jupiter Rug", "Peggy Rug", "Jathan Mirror", "Roen Wall Cabinet", "Gael Office Chair",
//        //      "Kael 3 Seater sofa", "Iris Office Chair", "Elena Bedside Table", "Rina Bedside Table", "Amber Set of 2 Dining Chair - Silver White",
//        //      "Fern Outdoor Lounge Chair", "Hendrix Outdoor Lounge Chair - Gree", "Hendrix Outdoor Lounge Chair - Maroon", "Bailey Outdoor Lounge Chair - Green",
//        //      "Bailey Outdoor Lounge Chair - Blue", "Beryl Bedside Table", "Horton Outdoor Dining Table", "Amir Outdoor Dining Table", 
//        //      "Werner Outdoor Dining Table", "Jim 6 Seater Dining Table", "Ned Dining Table", "Mae Rug", "Kent TV Unit", "Dale 6 Chest of Drawers",
//        //      "Arya Office Desk", "Joseph Bed Frame - Black", "Shialex Display Cabinet", "Joseph Bed Frame - Blue", "Grayson Sideboard",
//        //      "Dulcie 3 seater Sofa", "Enzo Desk"
//        //  ];

//         // var productTitle = $(this).find(".card__heading.h5 a.full-unstyled-link").text().trim();
         
//         // if (excludedTitles.includes(productTitle)) {
//         //     return; // Skip this product
//         // }
      
//         // Update sale price
//         var priceElement = $(this).find(".price-item--sale.price-item--last");
//         var priceText = priceElement.text().trim();
//         var fromIndex = priceText.indexOf("From");
//         if (fromIndex !== -1) {
//             var originalPriceText = priceText.substring(fromIndex + 5).trim();
//             var price = parseFloat(originalPriceText.replace(/[^\d.]/g, ''));
//             var discount = 0.30;
//             var discountedPrice = price - (price * discount);
//             var finalPrice = discountedPrice % 1 === 0 ? discountedPrice.toFixed(0) : discountedPrice.toFixed(2);
//             priceElement.text(priceText.substring(0, fromIndex + 5) + "$" + finalPrice);
//         } else {
//             var price = parseFloat(priceText.replace(/[^\d.]/g, ''));
//             var discount = 0.30;
//             var discountedPrice = price - (price * discount);
//             var finalPrice = discountedPrice % 1 === 0 ? discountedPrice.toFixed(0) : discountedPrice.toFixed(2);
//             priceElement.text("$" + finalPrice);
//         }

//         // Update regular price
//         var regularPriceElement = $(this).find("s.price-item--regular");
//         if (regularPriceElement.length) {
//             var regularPriceText = regularPriceElement.text().trim();
//             var updatedRegularPriceText = regularPriceText.replace(" AUD", "").replace(/\.00$/, "");
//             regularPriceElement.text(updatedRegularPriceText);
//         }
//     });
// }
//     $('body').on('click', '.ss__pagination__page', function(){
//       setTimeout(function(){
//         priceUpdateOff()
//       }, 2000)
//   })
//   setTimeout(function(){
//     if ($('body').hasClass('body--name-- index_')) {
//       console.log('111111111111111111')
//       priceUpdateOff()
//     }
//   }, 4000)
  ///////////////////////////////////////////////stickyHeader///////////////////////////////////////////////////
  $('body').on('click', '.search-open', function(){
    $('.menu-list-custom').toggleClass('search-open')
    $('.header_search').toggle();
    $('.open-svg').toggle();
    $('.close-svg').toggle();    
  })
   var headerHeight = $('.header-wrapper').outerHeight();
    var searchOpenAdded = false;
    // Function to add or remove class based on the scroll position
    function toggleClassBasedOnScroll() {
        if ($(window).scrollTop() >= headerHeight && !searchOpenAdded) {
        $('.header-wrapper').addClass('scrolled');
        $('.header_search').hide();
        $('.opt-notifications_button').hide();
        $('.header__icon--account').hide();
        $('#heart-icon-bubble').hide();
        $('#cart-icon-bubble').before('<a href="javascript:void(0)" class="search-open"><div class="open-svg"><svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="32" height="32" rx="16" fill="#2C474B"></rect><path d="M21.9983 22.1668L21.9975 22.1668C21.9756 22.1669 21.9538 22.1627 21.9336 22.1544C21.9135 22.1462 21.8952 22.1342 21.8797 22.1189L18.9989 19.2381C18.9768 19.2079 18.9655 19.171 18.9669 19.1334C18.9685 19.0914 18.9859 19.0516 19.0156 19.022C19.0453 18.9923 19.0851 18.9749 19.127 18.9733C19.1647 18.9718 19.2015 18.9832 19.2318 19.0052L22.1125 21.8859C22.1126 21.886 22.1127 21.8862 22.1128 21.8863C22.1436 21.9174 22.161 21.9596 22.161 22.0034C22.161 22.0469 22.144 22.0886 22.1137 22.1197C22.0828 22.1497 22.0415 22.1666 21.9983 22.1668Z" fill="black" stroke="white"></path><path d="M20.6471 15.3334C20.6471 16.3882 20.3343 17.4193 19.7483 18.2964C19.1623 19.1735 18.3293 19.8571 17.3548 20.2607C16.3802 20.6644 15.3079 20.77 14.2733 20.5642C13.2388 20.3584 12.2884 19.8505 11.5426 19.1046C10.7967 18.3587 10.2887 17.4084 10.0829 16.3739C9.87716 15.3393 9.98278 14.2669 10.3864 13.2924C10.7901 12.3179 11.4737 11.4849 12.3508 10.8989C13.2278 10.3128 14.259 10 15.3138 10C16.0159 9.9974 16.7115 10.1334 17.3609 10.4003C18.0103 10.6671 18.6006 11.0595 19.098 11.5551C19.5953 12.0506 19.99 12.6394 20.2593 13.2878C20.5285 13.9361 20.6671 14.6313 20.6671 15.3334H20.6471Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></div><div class="close-svg" style="display: none;"><svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.8532 22.9999C22.7008 23.0008 22.5497 22.9716 22.4086 22.914C22.2676 22.8564 22.1392 22.7715 22.0311 22.6641L16.9942 17.6274C16.8046 17.4059 16.7054 17.1209 16.7167 16.8295C16.7279 16.5381 16.8487 16.2617 17.055 16.0554C17.2612 15.8492 17.5376 15.7284 17.829 15.7172C18.1204 15.7059 18.4054 15.805 18.6269 15.9947L23.6637 21.0315C23.8793 21.2485 24.0004 21.542 24.0004 21.8479C24.0004 22.1537 23.8793 22.4472 23.6637 22.6641C23.448 22.8781 23.1569 22.9987 22.8532 22.9999Z" fill="#2C474B"></path><path d="M20.5028 10.2632C20.5028 12.0952 19.9595 13.8862 18.9417 15.4095C17.9238 16.9328 16.4771 18.1201 14.7845 18.8212C13.0919 19.5223 11.2294 19.7057 9.43252 19.3483C7.63565 18.9909 5.98513 18.1086 4.68966 16.8132C3.39419 15.5177 2.51197 13.8672 2.15455 12.0703C1.79714 10.2735 1.98058 8.41095 2.68168 6.71834C3.38278 5.02573 4.57005 3.57901 6.09336 2.56117C7.61667 1.54333 9.4076 1.00007 11.2397 1.00007C12.459 0.995492 13.6673 1.23173 14.7952 1.69519C15.923 2.15866 16.9483 2.84025 17.8121 3.70086C18.676 4.56148 19.3614 5.58416 19.8291 6.71028C20.2968 7.8364 20.5375 9.04379 20.5375 10.2632H20.5028Z" stroke="#2C474B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg></div></a>');
        
        // Update the variable to indicate that the element has been added
        searchOpenAdded = true;
    } else if ($(window).scrollTop() < headerHeight && searchOpenAdded) {
          var headerSearch = $('.header_search');
            // Check if the element is currently visible
            if (headerSearch.is(':visible')) {
                $('.menu-list-custom').toggleClass('search-open')
                $('.header_search').toggle();
                $('.open-svg').toggle();
                $('.close-svg').toggle();
            }
        $('.header-wrapper').removeClass('scrolled');
        $('.header_search').show();
        $('.opt-notifications_button').show();
        $('.header__icon--account').show();
        $('#heart-icon-bubble').show();
        $('.search-open').remove();
        
        // Update the variable to indicate that the element has been removed
        searchOpenAdded = false;
    }
    }
     $(document).on('click', function(event) {
          // Check if the click is outside the .search-open element
          if (!$(event.target).closest('.search-open').length && !$(event.target).closest('.header_search').length) {
            if ($('.header_search').length && $('.header_search').css('display') !== 'none') {
              // Clicked outside the .search-open
              console.log('Clicked outside .search-open');
              $('.close-svg').trigger('click')
              // Perform your desired action here
            }
          }
      });
    // Initial check
    toggleClassBasedOnScroll();
    
    // Listen for scroll event
    $(window).scroll(function() {
        toggleClassBasedOnScroll();
    });
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
   $(document).on('mouseenter', ".bestseller_product", function(e) {
    $(this).find('.motion-reduce').hide();
    $(this).find('.second-hover-image').show();
  });
  $(document).on('mouseleave', ".bestseller_product", function(e) {
    $(this).find('.second-hover-image').hide();
    $(this).find('.motion-reduce').show();
  });
  // $('.ajax-cart-item__total span:first').text('Subtotal');
  const cont = jQuery('#zooomy-head-wishlist-icon').html();
  jQuery('#heart-icon-bubble').append(cont); 
  jQuery('.ajax-cart-item__total').insertBefore('.custom_mini_cart_total_main .ajax-cart-item__total:eq(1)');
  // Move the element with class 'ajax-cart-item__total_with_original' to the third position
  jQuery('.ajax-cart-item__total_with_original').insertBefore('.free-shipping-grid');
  $('.quantity-avl').each(function() {
    if ($(this).text().trim() === '') {
        $(this).hide();
    }
  });

   $('.dd-reviews-slider').slick({
      autoscroll: true,
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
    });

  setTimeout(function(){
    var counter_html; 

    if($('#heart-icon-bubble #zooomy-wishlist-counter').length > 0){
      if($('#heart-icon-bubble #zooomy-wishlist-counter span').length > 0){
        counter_html = $('#heart-icon-bubble #zooomy-wishlist-counter span');
        if(counter_html.length > 0){
          $('#heart-icon-bubble #zooomy-wishlist-counter').addClass('show');
          $('#heart-icon-bubble #zooomy-wishlist-counter').show();
          $('#heart-icon-bubble #zooomy-wishlist-counter span').show();
        }else{
          $('#heart-icon-bubble #zooomy-wishlist-counter').removeClass('show');
          $('#heart-icon-bubble #zooomy-wishlist-counter').hide();
        }
      }else{
        counter_html = $('#heart-icon-bubble #zooomy-wishlist-counter').html();
        if(counter_html.length > 0){
          $('#heart-icon-bubble #zooomy-wishlist-counter').addClass('show');
          $('#heart-icon-bubble #zooomy-wishlist-counter').show();
        }else{
          $('#heart-icon-bubble #zooomy-wishlist-counter').removeClass('show');
          $('#heart-icon-bubble #zooomy-wishlist-counter').hide();
        }
      }
    }
    
  }, 1200);
  
  
  $('.product-sec-main .product-form__input.product-form__quantity quantity-input.quantity .qty-plus').on('click', function(){
    var quantity = $(this).closest('.product-form__input.product-form__quantity').find('.quantity__input').val();
    var new_quantity;
    var old_quantity;
    if(quantity != '' && quantity != 'undefined'){
      old_quantity = $('.product_custom_cart_qty').val();
      if(old_quantity !== false && typeof old_quantity !== 'undefined'){
        new_quantity = parseInt(old_quantity)+ parseInt(1);
        $('.product_custom_cart_qty').val(new_quantity);
      }
    }
  }) 

  $('.product-sec-main .product-form__input.product-form__quantity quantity-input.quantity .qty-minus').on('click', function(){
    var quantity = $(this).closest('.product-form__input.product-form__quantity').find('.quantity__input').val();
    var new_quantity;
    var old_quantity; 
    if(quantity != '' && quantity != 'undefined'){
      if($(this).closest('.product-form__input.product-form__quantity').find('.quantity__input').val() > 1){
        old_quantity = $(this).closest('.product-form__input.product-form__quantity').find('.quantity__input').val();
        if(old_quantity != '' && old_quantity != 'undefined' && old_quantity > 0){
          new_quantity = parseInt(old_quantity)-parseInt(1);
          $('.product_custom_cart_qty').val(new_quantity);
         } 
      }
    }
  }) 
  
  /* $('.quantity .button-cart-plus').on('click', function(){
    var quantity = $(this).prev().val();
    var new_quantity;
    var old_quantity;
    if(quantity != '' && quantity != 'undefined'){
      old_quantity = $(this).prev().val();
      if(old_quantity !== false && typeof old_quantity !== 'undefined'){
        new_quantity = parseInt(old_quantity)+ parseInt(1);
        //$(this).prev().val(new_quantity)
        $(this).closest('.quantity').find('input.quantity__input').val(new_quantity);
        $(this).closest('.quantity').find('input.quantity__input').trigger('change');
      }
    }   
  }) 

  $('.quantity .button-cart-minus').on('click', function(){
    var quantity = $(this).closest('.product-form__input.product-form__quantity').find('.quantity__input').val();
    var new_quantity;
    var old_quantity; 
    if(quantity != '' && quantity != 'undefined'){
      console.log($(this).next().val())
      if($(this).next().val() > 1){
        old_quantity = $(this).next().val();
        if(old_quantity != '' && old_quantity != 'undefined' && old_quantity > 0){
            new_quantity = parseInt(old_quantity)-parseInt(1);
            $('.quantity__input').val(new_quantity)
            console.log(new_quantity)
        } 
      }
    }
    $('.quantity__input').focus();
  }) */

  //  $("fieldset.js.product-form__input input[type='radio']").on("click", function() {
  //   var selectedValue = $(this).val();
  //   setTimeout(function(){
  //     var price = $('.shopify_price_container .price__sale .price-item.price-item--sale.price-item--last').text()
  //     var consoleOutputText = price;
  //         // Split the text by space character
  //     var values = consoleOutputText.split(" ");
      
  //     // Find the index of the first element that contains the price
  //     var firstPriceIndex = values.findIndex(function(element) {
  //       return element.includes("$");
  //     });
      
  //     // Get the first price from the array
  //     var firstPrice = values[firstPriceIndex];
  //      // Convert the price string to a number and apply the 15% discount
  //     var priceWithoutCurrency = parseFloat(firstPrice.replace(/[^\d.]/g, ''));
  //     if ($('.mid-sale-discount-batches').hasClass('mattress-deep-dream-offer')) {
  //         // console.log('3333333333330000000000000')
  //       var discountedPrice = priceWithoutCurrency * 0.80;
  //       console.log(discountedPrice)
  //     }else if ($('.dicount-pernt').hasClass('25%')) {
  //       var discountedPrice = priceWithoutCurrency * 0.75;
  //     }else{
  //       var discountedPrice = priceWithoutCurrency * 0.80;
  //     }
  //     var discountedPrice = priceWithoutCurrency * 0.80;
  //     // var discountedPrice = priceWithoutCurrency * 0.80;
  //     console.log(values)
  //     console.log("First price:", firstPrice);
  //     // if ($('body').hasClass('product-6822546636842')) {  
  //     //   if(selectedValue == 'Queen'){
  //     //     $('.dicount-pernt-30 h4').text('SAVE EXTRA 30% OFF');
  //     //     $('.dicount-pernt-30 p').text('ON THIS MATTRESS');
  //     //      $(".product_mattress-deepdream .mid-sale-discount-batches li h4").attr('style', 'color: #FACB07 !important');
  //     //     $(".product_mattress-deepdream .mid-sale-discount-batches li p").attr('style', 'color: #FACB07 !important');
  //     //     $(".product_mattress-deepdream .custom-price h5 ").attr('style', 'color: #FACB07 !important');
      
  //     //     $('.product_mattress-deepdream .mid-sale-discount-batches').attr('style', 'background: #192e59 !important');
  //     //     var discountedPrice = priceWithoutCurrency * 0.70;
  //     //   }else{
  //     //      $(".product_mattress-deepdream .mid-sale-discount-batches li h4").removeAttr('style');
  //     //     $(".product_mattress-deepdream .mid-sale-discount-batches li p").removeAttr('style');
  //     //     $(".product_mattress-deepdream .custom-price h5 ").removeAttr('style');
      
  //     //     $('.product_mattress-deepdream .mid-sale-discount-batches').removeAttr('style');
  //     //     $('.dicount-pernt-30 h4').text('SAVE EXTRA 20% OFF')
  //     //     var discountedPrice = priceWithoutCurrency * 0.80;
  //     //   }
  //     // }else{
  //     //   console.log('111111111111')
  //     // }
  //     $('.custom-price').find('h5').text("$" + discountedPrice.toFixed(2));
  //   }, 1000)
  // });
  
  setTimeout(function(){
    jQuery('.custom_mini_cart_total .new_subtotal-grid').show();
  }, 2000)

   // When a radio button in the "Size" fieldset is clicked
  $("fieldset.js.product-form__input input[name='Size']").click(function () {
    // Check if none is selected in the "Color" fieldset and set the first option if none is selected
    let colorFieldsetRadios = $("fieldset.js.product-form__input.color_option_field input[name='Color']");
    if (colorFieldsetRadios.filter(':checked').length === 0) {
        colorFieldsetRadios.first().prop('checked', true);
      var val = colorFieldsetRadios.first().val();
      jQuery('variant-radios .product-form__input input[name="Color"]:checked').closest('.product-form__input').find('legend.form__label').html('Color: <span class="color_slected">'+val+'</span>');
      colorFieldsetRadios.first().addClass('click7777777777');
    }
  });

  // When a radio button in the "Color" fieldset is clicked
  $("fieldset.js.product-form__input.color_option_field input[name='Color']").click(function () {
    // Check if none is selected in the "Size" fieldset and set the first option if none is selected
    let sizeFieldsetRadios = $("fieldset.js.product-form__input input[name='Size']");
    if (sizeFieldsetRadios.filter(':checked').length === 0) {
        sizeFieldsetRadios.first().prop('checked', true);
      sizeFieldsetRadios.first().trigger('click');
    }
  });
 ////////////////////////////// Recently viewd products popUp on click of overlay///////////////////////////////////////
 $(document).mouseup(function (e) {
    // Check if opt-notifications opt-shadow has the class active
    if ($('.opt-notifications.opt-shadow').hasClass('active')) {
        var container = $(".recent_view_product_inner");

        // Check if the target of the click is not the container or its descendants
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            console.log('Clicked outside .recent_view_product_inner');
            // Hide the popup
            $('.opt-notifications_button').trigger('click')
        }
    }
});
  
 // Function to check if .quantity-avl span is blank
function checkQuantityAvl() {
    if ($.trim($('.quantity-avl').text()) === '') {
        console.log('.quantity-avl span is blank');
        $('#ISR_button').hide();
    } else {
        $('#ISR_button').hide(); // Show the button if needed
        console.log('.quantity-avl span is not blank');
    }
}

// MutationObserver configuration
const observerConfig = { childList: true, subtree: true };

// Callback function to handle mutations
const mutationCallback = function (mutationsList, observer) {
    for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
            // Check if .quantity-avl span is present after a mutation
            if ($('.quantity-avl').length > 0) {
                // Stop observing once the element is found
                observer.disconnect();
                // Check if .quantity-avl span is blank
                checkQuantityAvl();
            }
        }
    }
};

// Select the target node (parent of .quantity-avl span)
const targetNode = document.querySelector('.dispatch_deatil');

// Check if the target node exists before observing
if (targetNode) {
    // Create a MutationObserver instance with the callback and configuration
    const observer = new MutationObserver(mutationCallback);

    // Start observing the target node for mutations
    observer.observe(targetNode, observerConfig);
} else {
    console.log("Target node not found");
}
  ////////////////////////////// Recently viewd products popUp on click of overlay///////////////////////////////////////
  // Check if the delivery_date contains 'Not Eligible'
  function updateDeliveryDate() {
    // Check if the delivery_date contains 'Not Eligible'
    var deliveryDateElement = document.querySelector('.delivery_date');
    if (deliveryDateElement && deliveryDateElement.textContent.trim() === 'Not Eligible') {
        // If 'Not Eligible', get the dispatch_date and add one day to it
        var dispatchDateElement = document.querySelector('.dispatch_date');
        if (dispatchDateElement) {
            var dispatchDate = new Date(dispatchDateElement.textContent.trim());

            // Add one day to the dispatch date
            dispatchDate.setDate(dispatchDate.getDate() + 1);

            // Format the new date as 'Day Month Year' (e.g., 14 December 2023)
            var day = dispatchDate.getDate();
            var month = dispatchDate.toLocaleString('default', { month: 'long' });
            var year = dispatchDate.getFullYear();

            // Construct the formatted date
            var formattedDate = day + ' ' + month + ' ' + year;

            // Update the delivery_date with the new date
            deliveryDateElement.textContent = formattedDate;
        }
    }
}
  setTimeout(function(){
    // Check if the delivery_date contains 'Not Eligible'
    updateDeliveryDate();
  }, 5000)
 
  
})

function variantChange(obj) {

    var discountPercentage = $("input[name='bundle_product']").val();
  
      var compareAtPrice = obj.compare_at_price;
      var price = obj.price;
      var price_with_disc = price - (price*0.30)
      var originalPrice = obj.price;
      var percentageDifferenceS = ((compareAtPrice - price) / compareAtPrice) * 100;
      var showPercentage = Math.round(percentageDifferenceS + 30);
      
      jQuery('.sale-radio-badge').text(+showPercentage+ "% Off");
      jQuery('.mid-sale-discount-batches .total-saving-text').text("Save $"+ Math.round((compareAtPrice - price_with_disc) / 100));
      // jQuery('.mid-sale-discount-batches .total-saving-text').text("Unlock more savings in cart");
      var discountedPrice = (obj.price * 0.70)/100;
      var compPrice = compareAtPrice /100;
  

        jQuery('.price-compare-new').text("$" + compPrice.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","));
  
        originalPrice = originalPrice / 100;
    

        jQuery('.originalPrice').text("$" + originalPrice.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","));
        let $salePrice = $(this).find(".custom-price");        
            let discount = 0;
            // if (originalPrice > 1000) {
            //     discount = 40;
            // } else if (originalPrice > 500) {
            //     discount = 30;
            // } else if (originalPrice > 150) {
            //     discount = 20;
            // }
discount = 50;
            if (discount > 0) {
              let newPrice = originalPrice - (originalPrice * discount / 100);
              jQuery('.price-section .custom-price').text("$" + newPrice.toFixed(2));

              // let discountPercentage = ((compPrice - newPrice) / compPrice) * 100;
              let discountPercentage = ((compPrice - originalPrice) / compPrice) * 100;
              
              discountPercentage = Math.floor(discountPercentage);
              $('.discount-percent').text(discountPercentage +discount+'% OFF')

              let dollarSavings = (compPrice - newPrice).toFixed(2);
              jQuery('.mid-sale-discount-batches .total-saving-text').text("Save $"+ dollarSavings);
              // jQuery('.mid-sale-discount-batches .total-saving-text').text("Unlock more savings in cart");
              // alert(dollarSavings)
            }

  
  
}

  // Detect variant change
  jQuery(document).on('change', 'select[name="id"], input[name="id"], input[name="Size"]', function() {
    $(".loader-wrapper").removeClass('hide-loader');
    const urlParams = new URLSearchParams(window.location.search);
    var variantId = '';
    variantId = urlParams.get('variant')
    
    var variant = productVariants.find(v => v.id == variantId);
    
    // Get the variant's inventory data from the productVariantsInventory object
    var variantData = productVariantsInventory[variantId];
    console.log(variantData)
    if (variantData) {
        // Check stock level and availability
        if (variantData.available && variantData.inventory_quantity < 1 && variantData.inventory_management) {
            // Out of stock, show Pre-order banner
          // $('.radio-sale-banner').show();
          // $('.price-section').hide();
          // $('.discount_sale_bar_section').hide();
          setTimeout(function(){
          $('.product_detail_custom_add_to_cart span').text('Pre-order')
            $('.open-notify-me').show()
            $('.open-notify-me').parent().show()
            $('#ISR_button').show()
          }, 1500)
            // $('.buy-now-banner').hide();
            // $('.pre-order-banner').show();
            // $('.pre-order-banner .delivery_date').text('Estimated arrival: ' + calculateEstimatedArrivalDate());
            // setCountdownTimer();
        } else if (variantData.inventory_quantity < 5 && variantData.inventory_quantity > 0 ) {
          $('.mid_sale_header_bar.ddmatress_sale_header_bar').show()
          $('.preOrder-updates').html(`<span class="lowStock-class">Low Stock - Don't miss out</span>`)
        }else {
          
           $('#ISR_button').hide()
          $('.discount_sale_bar_section').show();
          $('.open-notify-me').hide()
          $('.open-notify-me').parent().hide()
          $('.preOrder-updates').html('<span class="inStock-class">In Stock - Ready to ship</span>')
          // $('.radio-sale-banner').hide();
          // $('.price-section').show();
        }
    } else {
        console.error("Variant data not found.");
    }
    setTimeout(function(){
      $(".loader-wrapper").addClass('hide-loader');
      var regularPrice = $(".price-section .price-compare-new").text().trim().replace(" AUD", "");
     $("input[name='properties[Retail-price]']").val(regularPrice);
    }, 2000)
    
  });
